import React from "react";
import { Edit, Save, Trash2, X } from "lucide-react";
import EditFloatingActions from "./EditFloatingActions";

const AdminCardActions = ({
    editing = false,
    onEdit,
    onSave,
    onCancel,
    onDelete,
    disabled = false,
}) => {
    return (
        <>
            <div className={`admin-card-actions ${editing ? "is-editing" : "is-idle"}`}>
                {editing ? (
                    <>
                        <button
                            type="button"
                            className="admin-card-actions__button is-primary-save"
                            onClick={onSave}
                            title="Зберегти"
                            aria-label="Зберегти"
                            disabled={disabled}
                        >
                            <Save size={16} />
                        </button>
                        {onCancel ? (
                            <button
                                type="button"
                                className="admin-card-actions__button is-cancel"
                                onClick={onCancel}
                                title="Скасувати"
                                aria-label="Скасувати"
                                disabled={disabled}
                            >
                                <X size={16} />
                            </button>
                        ) : null}
                        {onDelete ? (
                            <button
                                type="button"
                                className="admin-card-actions__button is-delete"
                                onClick={onDelete}
                                title="Видалити"
                                aria-label="Видалити"
                                disabled={disabled}
                            >
                                <Trash2 size={16} />
                            </button>
                        ) : null}
                    </>
                ) : (
                    <button
                        type="button"
                        className="admin-card-actions__button is-primary-edit"
                        onClick={onEdit}
                        title="Редагувати"
                        aria-label="Редагувати"
                        disabled={disabled}
                    >
                        <Edit size={16} />
                    </button>
                )}
            </div>
            {editing ? (
                <EditFloatingActions onSave={onSave} onCancel={onCancel} disabled={disabled} />
            ) : null}
        </>
    );
};

export default AdminCardActions;
